module.exports = __webpack_public_path__ + "static/meeting_room-b6247de001f974a60d093b6024f92832.jpg";